
import React, { Suspense, lazy } from 'react';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';

const AboutSection = lazy(() => import('./components/AboutSection'));
const ProjectsSection = lazy(() => import('./components/ProjectsSection'));
const ContactSection = lazy(() => import('./components/ContactSection'));
const Footer = lazy(() => import('./components/Footer'));

function App() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Navbar />
      <HeroSection />
      <Suspense fallback={<Box sx={{ minHeight: 120 }} />}>
        <AboutSection />
        <ProjectsSection />
        <ContactSection />
        <Footer />
      </Suspense>
    </Box>
  );
}

export default App;
